import React from "react";
import MapInterface from "../pages/Map";

// Reusable wrapper for MapInterface, with flexible container style
function MapContainer({
  layers = [],
  predictedLayers = [],
  heatmaps = [],
  mapType = "satellite",
  onMapClick,
  marker,
  bufferRadiusMeters,
  bounds,
  center,
  zoom,
  style,
  className,
}) {
  return (
    <div className={className} style={style}>
      <MapInterface
        layers={layers}
        predictedLayers={predictedLayers}
        heatmaps={heatmaps}
        mapType={mapType}
        onMapClick={onMapClick}
        marker={marker}
        bufferRadiusMeters={bufferRadiusMeters}
        bounds={bounds}
        center={center}
        zoom={zoom}
        containerStyle={{ height: "100%", width: "100%", border: "1px solid #2b4f2f" }}
      />
    </div>
  );
}

export default MapContainer;
